import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, HostListener, inject, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AccordionModule } from 'primeng/accordion';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ChartModule } from 'primeng/chart';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { DropdownModule } from 'primeng/dropdown';
import { ImageModule } from 'primeng/image';
import { ProgressBarModule } from 'primeng/progressbar';
import { RatingModule } from 'primeng/rating';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { TooltipModule } from 'primeng/tooltip';
import { Currency, getCurrencyDescription } from '../../../models/enums/UserRole';
import { InstituteCommonDetailsV2Response } from '../../../models/institute/instituteCommonDetailsV2Response';
import { InstituteUnderGraduateDetailsV2Response } from '../../../models/institute/instituteUnderGraduateDetailsV2Response';
import { InstituteMasterDetailsV2Response } from '../../../models/institute/InstituteMasterDetailsV2Response';
import { InstituteGraduateSchoolsWithInV2Response } from '../../../models/institute/instituteGraduateSchoolsWithInV2Response';
import { InstituteService } from '../../../services/institute/institute.service';
import { InstituteTotalEnrollmentsV2Response } from '../../../models/institute/instituteTotalEnrollmentsV2Response';
import { InstituteDetailAlumniComponent } from '../institute-detail-alumni/institute-detail-alumni.component';

interface InstituteRaceEthnicityData {

  underGraduateStudents: number | null;
  graduateStudents: number | null;
  //for UG
  fulltimeEnrollment: number | null;
  maleEnrollment: string | null;
  femaleEnrollment: string | null;
  // indianStudents: string | null;
  //For PG
  // totalGraduateEnrollment: number | null;
  // partTimeGraduateEnrollment: number | null;
  // maleGraduateEnrollment: string | null;
  // femaleGraduateEnrollment: string | null;

}

@Component({
  selector: 'app-institute-detail-uk',
  standalone: true,
  imports: [CommonModule, FormsModule, CheckboxModule, ImageModule, BreadcrumbModule,
    RouterModule, ChipModule, TooltipModule, AccordionModule, DropdownModule, ProgressBarModule,
    RatingModule, ScrollPanelModule, ChartModule, InstituteDetailAlumniComponent],
  templateUrl: './institute-detail-uk.component.html',
  styleUrl: './institute-detail-uk.component.scss'
})
export class InstituteDetailUkComponent implements OnChanges {
  ngOnChanges(): void {
    if (this.isUGDetails(this.instituteUGMDetails)) {
      this.popularEmployers = this.instituteUGMDetails.popularEmployers;
      this.scholarships = this.instituteUGMDetails.findScholarships || [];
    }
    this.listGraduateSchools();
    this.listMajors();
    this.prepareChartData();
  }
  private instituteService = inject(InstituteService);
  undergradStudents: number | undefined;
  gradStudents?: number | undefined;
  @Input() instituteUGMDetails!: InstituteUnderGraduateDetailsV2Response | InstituteMasterDetailsV2Response;
  instituteBachelorMajors: InstituteTotalEnrollmentsV2Response[] = [];
  instituteGraduateMajors: InstituteTotalEnrollmentsV2Response[] = [];
  instituteDoctoralMajors: InstituteTotalEnrollmentsV2Response[] = [];
  @Input() institute: InstituteCommonDetailsV2Response | undefined;
  @Input() selectedProgramType: string | undefined;
  graduateSchoolsWithin: InstituteGraduateSchoolsWithInV2Response[] = [];
  popularEmployers?: string | null;
  raceData: InstituteRaceEthnicityData | null = null;
  raceDataUMG: InstituteRaceEthnicityData | null = null;
  pieData: any;
  pieOptions: any;
  pieDataUMG: any;
  pieOptionsUMG: any;
  @ViewChild('chart1') chart1: any;
  @ViewChild('chart2') chart2: any;
  @Output() requestDisplayCourses = new EventEmitter<void>();
  scholarships: string[] = [];
  showAllGraduateSchoolsWithin = false;
  showAllScholarships = false;
  showAllUGMajors = false;
  showAllPGMajors = false;
  showAllDoctoralMajors = false;

  get visibleScholarships() {
    return this.showAllScholarships ? this.scholarships : this.scholarships.slice(0, 3);
  }
  toggleScholarshipsView() {
    this.showAllScholarships = !this.showAllScholarships;
  }
  get visibleGraduateSchoolsWithin() {
    return this.showAllGraduateSchoolsWithin ? this.graduateSchoolsWithin : this.graduateSchoolsWithin.slice(0, 3);
  }
  toggleGraduateSchoolsView() {
    this.showAllGraduateSchoolsWithin = !this.showAllGraduateSchoolsWithin;
  }

  get visibleUGMajors() {
    return this.getVisibleMajors(this.instituteBachelorMajors, this.showAllUGMajors);
  }
  get visiblePGMajors() {
    return this.getVisibleMajors(this.instituteGraduateMajors, this.showAllPGMajors);
  }
  get visibleDoctoralMajors() {
    return this.getVisibleMajors(this.instituteDoctoralMajors, this.showAllDoctoralMajors);
  }

  getVisibleMajors(courses: any[], showAll: boolean): any[] {
    return showAll ? courses : courses.slice(0, 3);
  }

  toggleMajorsView(key: 'UG' | 'PG' | 'Doctoral') {
    const prop = `showAll${key}Majors` as 'showAllUGMajors' | 'showAllPGMajors' | 'showAllDoctoralMajors';
    this[prop] = !this[prop];
  }

  triggerDisplayCourses() {
    this.requestDisplayCourses.emit();
  }

  constructor(private cdr: ChangeDetectorRef) { }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.forceChartResize();
  }

  forceChartResize() {
    setTimeout(() => {
      this.chart1?.refresh();
      this.chart2?.refresh();
    }, 100); // allow DOM to update
  }
  listGraduateSchools() {
    this.instituteService.listInstituteGraduateSchoolsWithIn(this.institute!.id).subscribe({
      next: (response) => {
        this.graduateSchoolsWithin = response.result;
      }
    })
  }
  listMajors() {
    this.instituteService.listInstituteTotalEnrollments({
      instituteId: this.institute!.id,
      levelOfCrediential: 'Bachelor'
    }).subscribe({
      next: (response) => {
        this.instituteBachelorMajors = response.result;
      }
    });
    this.instituteService.listInstituteTotalEnrollments({
      instituteId: this.institute!.id,
      levelOfCrediential: 'Master'
    }).subscribe({
      next: (response) => {
        this.instituteGraduateMajors = response.result;
      }
    });
    this.instituteService.listInstituteTotalEnrollments({
      instituteId: this.institute!.id,
      levelOfCrediential: 'Doctoral'
    }).subscribe({
      next: (response) => {
        this.instituteDoctoralMajors = response.result;
      }
    })
  }

  getAmount(currency: Currency, amount: string | number): string {
    const amountNum = Number(amount);
    const formattedAmount = amountNum.toLocaleString('en-US'); // or 'en-US' based on formatting needs
    return `${getCurrencyDescription(currency)} ${formattedAmount}`;
  }

  isUGDetails(details: InstituteUnderGraduateDetailsV2Response | InstituteMasterDetailsV2Response): details is InstituteUnderGraduateDetailsV2Response {
    return (
      details != null &&
      'totalApplicants' in details
    );
  }

  // ✅ Type guard for Masters
  isMastersDetails(details: InstituteUnderGraduateDetailsV2Response | InstituteMasterDetailsV2Response): details is InstituteMasterDetailsV2Response {
    return (
      details != null &&
      'graduateStudentsEnrolled' in details
    );
  }
  normalizeToNumber(value: string | number | null): number {
    if (value === null || value === undefined) return 0;
    if (typeof value === 'number') return value;
    if (typeof value === 'string') {
      if (value.includes('%')) {
        return parseFloat(value.replace('%', ''));
      }
      return parseFloat(value); // for "7695" style
    }
    return 0;
  }
  stringToPercent(amount: string | number): number {

    const amountNum = (Number(amount));

    return Number((amountNum * 100).toFixed(2));
  }

  prepareChartData() {
    this.raceDataUMG = {
      underGraduateStudents: this.stringToPercent(this.normalizeToNumber(this.instituteUGMDetails?.underGraduate ?? 0)) ?? null,
      graduateStudents: this.stringToPercent(this.normalizeToNumber(this.instituteUGMDetails?.postGraduate ?? 0)) ?? null,
      fulltimeEnrollment: null,
      maleEnrollment: null,
      femaleEnrollment: null,
      // indianStudents:  null,
      // totalGraduateEnrollment:  null,
      // partTimeGraduateEnrollment:  null,
      // maleGraduateEnrollment: null, 
      // femaleGraduateEnrollment: null 
    };
    if (this.isUGDetails(this.instituteUGMDetails)) {
      this.raceData = {
        underGraduateStudents: null,
        graduateStudents: null,
        fulltimeEnrollment: null,
        maleEnrollment: this.instituteUGMDetails?.maleEnrollment ?? null,
        femaleEnrollment: this.instituteUGMDetails?.femaleEnrollment ?? null,
        // indianStudents:  this.instituteUGMDetails?.fullTimeUnderGraduateIndianStudents ?? null,
        // totalGraduateEnrollment:  null,
        // partTimeGraduateEnrollment:  null,
        // maleGraduateEnrollment: null, 
        // femaleGraduateEnrollment: null 
      };
    } else if (this.isMastersDetails(this.instituteUGMDetails)) {
      this.raceData = {
        underGraduateStudents: null,
        graduateStudents: null,
        fulltimeEnrollment: null,
        maleEnrollment: this.instituteUGMDetails?.maleEnrollment ?? null,
        femaleEnrollment: this.instituteUGMDetails?.femaleEnrollment ?? null,
        // indianStudents:   null,
        // totalGraduateEnrollment:   null,
        // partTimeGraduateEnrollment:  this.instituteUGMDetails?.partTimeEnrollment ?? null,
        // maleGraduateEnrollment: this.instituteUGMDetails?.maleGraduateEnrollment ?? null, 
        // femaleGraduateEnrollment: this.instituteUGMDetails?.femaleGraduateEnrollment ?? null 
      };
    }

    if (this.raceDataUMG) {
      this.pieDataUMG = {
        labels: [
          'Undergraduate Students',
          'Graduate Students',
          // 'Fulltime Undergraduate Enrollment',
          // 'Male Undergraduate Enrollment',
          // 'Female Undergraduate Enrollment',
          // 'Indian Undergraduate Enrollment',
          // 'Total Graduate Enrollment',
          // 'Part-time Graduate Enrollment',
          // 'Male Graduate Enrollment', 
          // 'Female Graduate Enrollment' 
        ],
        datasets: [
          {
            data: [
              this.normalizeToNumber(this.raceDataUMG.underGraduateStudents),
              this.normalizeToNumber(this.raceDataUMG.graduateStudents),
              // this.normalizeToNumber(this.raceDataUMG.fulltimeEnrollment),
              // this.normalizeToNumber(this.raceDataUMG.maleEnrollment),
              // this.normalizeToNumber(this.raceDataUMG.femaleEnrollment),
              // this.normalizeToNumber(this.raceDataUMG.indianStudents),
              // this.normalizeToNumber(this.raceDataUMG.totalGraduateEnrollment),
              // this.normalizeToNumber(this.raceDataUMG.partTimeGraduateEnrollment),
              // this.normalizeToNumber(this.raceDataUMG.maleGraduateEnrollment),
              // this.normalizeToNumber(this.raceDataUMG.femaleGraduateEnrollment),
            ],
            backgroundColor: [
              // '#FF6384',
              // '#36A2EB',
              // '#FFCE56',
              // '#4BC0C0',
              '#CED12A',
              // '#FF9F40',
              // '#808080',
              // '#008000',
              // '#FFA07A',
              '#000086'
            ],
            hoverBackgroundColor: [
              // '#FF6384',
              // '#36A2EB',
              // '#FFCE56',
              // '#4BC0C0',
              '#CED12A',
              // '#FF9F40',
              // '#808080',
              // '#008000',
              // '#FFA07A',
              '#000086'
            ],
          },
        ],
      };

      this.pieOptionsUMG = {
        plugins: {
          legend: {

            position: 'top',
            labels: {
              color: '#495057',
            },
          },
          tooltip: {
            callbacks: {
              label: (context: any) => {
                const label = context.label || '';
                const data = context.dataset.data;
                const value = context.parsed;
                const total = data.reduce((sum: number, val: any) => sum + val, 0);
                const percentage = total ? ((value / total) * 100).toFixed(0) : 0;
                return `${label}: (${percentage}%)`;
              },
            },
          },
        },
      };

    }

    if (this.raceData) {
      this.pieData = {
        labels: [
          // 'Undergraduate Students',
          // 'Graduate Students',
          // 'Fulltime Undergraduate Enrollment',
          'Male Enrollment',
          'Female Enrollment',
          // 'Indian Undergraduate Enrollment',
          // 'Total Graduate Enrollment',
          // 'Part-time Graduate Enrollment',
          // 'Male Graduate Enrollment', 
          // 'Female Graduate Enrollment' 
        ],
        datasets: [
          {
            data: [
              // this.normalizeToNumber(this.raceData.underGraduateStudents),
              // this.normalizeToNumber(this.raceData.graduateStudents),
              // this.normalizeToNumber(this.raceData.fulltimeEnrollment),
              this.toPercentValue(this.raceData.maleEnrollment) ?? 0,
  this.toPercentValue(this.raceData.femaleEnrollment) ?? 0,
              // this.normalizeToNumber(this.raceData.indianStudents),
              // this.normalizeToNumber(this.raceData.totalGraduateEnrollment),
              // this.normalizeToNumber(this.raceData.partTimeGraduateEnrollment),
              // this.normalizeToNumber(this.raceData.maleGraduateEnrollment),
              // this.normalizeToNumber(this.raceData.femaleGraduateEnrollment),
            ],
            backgroundColor: [
              // '#FF6384',
              // '#36A2EB',
              // '#FFCE56',
              // '#4BC0C0',
              '#CED12A',
              // '#FF9F40',
              // '#808080',
              // '#008000',
              // '#FFA07A',
              '#000086'
            ],
            hoverBackgroundColor: [
              // '#FF6384',
              // '#36A2EB',
              // '#FFCE56',
              // '#4BC0C0',
              '#CED12A',
              // '#FF9F40',
              // '#808080',
              // '#008000',
              // '#FFA07A',
              '#000086'
            ],
          },
        ],
      };

      this.pieOptions = {
        plugins: {
          legend: {

            position: 'top',
            labels: {
              color: '#495057',
            },
          },
          tooltip: {
            callbacks: {
              label: (context: any) => {
                const label = context.label || '';
                const data = context.dataset.data;
                const value = context.parsed;
                const total = data.reduce((sum: number, val: any) => sum + val, 0);
                const percentage = total ? ((value / total) * 100).toFixed(2) : 0;
                return `${label}: (${value}%)`;
              },
            },
          },
        },
      };

    }
  }
  toPercentValue(value: string | number | null | undefined): number | null {
  if (value === null || value === undefined || value === '') return null;
  const n = this.normalizeToNumber(value as any);
  if (!isFinite(n)) return null;
  if (typeof value === 'string' && value.includes('%')) return n;
  return n > 0 && n <= 1 ? Number((n * 100).toFixed(2)) : n;
}
formatPercent(value: string | number | null | undefined): string {
  const p = this.toPercentValue(value);
  return p === null ? 'N/A' : `${p}%`;
}
}
